import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { toggleBold } from 'roosterjs-editor-api';

const bold: RibbonButton = {
    key: 'bold',
    title: () => strings.bold,
    imageSrc: require('../svg/bold.svg'),
    shortcutWin: 'Ctrl+B',
    shortcutMac: '⌘+B',
    buttonState: formatState =>
        formatState.isBold ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleBold(plugin.getEditor()),
};

export default bold;
